export default __webpack_public_path__ + "static/media/SWT1180.34I-43206_-25830_0.780f219c.jpg";